exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".entry-details[data-v-4d7740f4] {\n  font-size: 1em;\n}\n.details-box[data-v-4d7740f4] {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-justify-content: space-evenly;\n          justify-content: space-evenly;\n  min-height: 150px;\n}\n.details-box .fa-plus[data-v-4d7740f4] {\n  font-size: 3em;\n}", ""]);

// exports
